import React from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';
import ProductImage from '@jetshop/ui/ProductList/ProductImage';
import { Price } from '../Price';
import ProductLink from '@jetshop/ui/ProductLink';
const RelatedProductsSection = styled('div')`
  width: 100%;
  margin-bottom: 12px;
`;
const RelatedProductsTitle = styled('h3')`
  font-weight: bold;
  font-size: 20px;
  line-height: normal;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  margin-bottom: 12px;
`;

const RelatedProductWrapper = styled('div')`
  width: 100%;
  height: 80px;
  margin-bottom: 12px;
  background-color: white;
  padding: 6px;
  display: flex;
  flex-direction: row;
`;

const StyledProductImage = styled(ProductImage)`
  border: 0.5px solid #cfcfcf;
`;

const ImageWrapper = styled('div')`
  width: 68px;
`;

const NamePriceSection = styled('div')`
  margin-left: 12px;
  max-width: 225px;
  ${Price.Wrapper} {
    font-weight: bold;
  }
`;

const ProductName = styled('p')`
  margin-bottom: 8px;
`;

const ViewProductButton = styled(ProductLink)`
  margin-left: auto;
  margin-right: 22px;
  align-self: center;
  width: 126.69px;
  height: 40px;
  background: #b24748;
  border-radius: 2px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-weight: 900;
  font-size: 14px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const RelatedProduct = ({ product }) => {
  return (
    <RelatedProductWrapper>
      <ImageWrapper>
        <StyledProductImage
          aspect={'1:1'}
          image={product.images[0]}
          badges={product.badges}
        />
      </ImageWrapper>
      <NamePriceSection>
        <ProductName>{product.name}</ProductName>
        <Price {...product} />
      </NamePriceSection>
      <ViewProductButton product={product}>{t('Show')}</ViewProductButton>
    </RelatedProductWrapper>
  );
};

const RelatedProducts = ({ relatedProducts, loading }) => {
  if (!relatedProducts || relatedProducts.length === 0) return null;

  return (
    <RelatedProductsSection>
      <RelatedProductsTitle>{t('Related products')}</RelatedProductsTitle>
      {relatedProducts.map(product => (
        <RelatedProduct product={product} />
      ))}
    </RelatedProductsSection>
  );
};

export default RelatedProducts;
